import type { SubfolderType } from "@shared/api";
import type { GpsUploadSource } from "@/lib/gallery-upload-gps";
import type { ImageUploadOutboxContext } from "@/lib/image-upload-outbox";
import { uploadImages, IMAGE_UPLOAD_CONCURRENCY } from "@/lib/image-upload";

/** Párhuzamos deal-mappa fotófeltöltés (Bemérés / Munkaátadás). */
export const DEAL_FOLDER_PHOTO_UPLOAD_CONCURRENCY = IMAGE_UPLOAD_CONCURRENCY;

export type DealFolderPhotosConcurrentParams = {
  uploadUrl: string;
  subfolderType: SubfolderType;
  files: File[];
  sources: GpsUploadSource[];
  productSlug?: string;
  context: ImageUploadOutboxContext;
  /** Alapértelmezés: {@link DEAL_FOLDER_PHOTO_UPLOAD_CONCURRENCY} */
  concurrency?: number;
  /** Minden sikeres POST után (pl. query invalidálás, szülő refetch). */
  onEachSuccess?: () => void;
};

/**
 * Thin wrapper a közös {@link uploadImages} motor fölött (deal-mappa cél).
 * Fájlonként POST, timeout + sikertelen feltöltés → image upload outbox.
 */
export async function uploadDealFolderPhotosConcurrent(
  opts: DealFolderPhotosConcurrentParams,
): Promise<{ anySuccess: boolean; queued: number }> {
  const res = await uploadImages({
    uploadUrl: opts.uploadUrl,
    files: opts.files,
    sources: opts.sources,
    extraFields: {
      subfolderType: opts.subfolderType,
      productSlug: opts.productSlug?.trim() || undefined,
    },
    context: opts.context,
    concurrency: opts.concurrency,
    onEachSuccess: () => opts.onEachSuccess?.(),
  });
  return { anySuccess: res.uploaded > 0, queued: res.queued };
}
